<template>
  <div class="v-user-balances">
    <b-card class="data-card wallets" no-body>
      <b-table
        empty-text="موردی یافت نشد"
        :items="items"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="filterOn"
        stacked="md"
        empty-filtered-html="نتیجه ای برای جستجوی شما یافت نشد"
        show-empty
        small
      >
        <template #cell(symbol)="row">
          {{ row.item.symbol.toUpperCase() }}
        </template>

        <template #cell(amount)="row">
          {{ row.item.amount }}
        </template>

        <template #cell(name)="row">
          <div class="icon-container">
            <CryptoIcons class="ml-3" :symbol="row.item.symbol" size="30"/>
            {{ row.item.symbol }}
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import http from "@/httpservices/HttpService"
import CryptoIcons from "@/components/CryptoIcons";

export default {
  name: "UserBalances",
  components: {
    CryptoIcons,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "name",
          label: "نام",
          sortable: false,
          sortDirection: "desc",
          class: "text-right",
        },
        {
          key: "symbol",
          label: "رمز ارز",
          sortable: false,
          sortDirection: "desc",
          class: "text-right",
        },

        {
          key: "amount",
          label: "موجودی",
          sortable: true,
          class: "",
        },

        {key: "actions", label: ""},
      ],

      filter: null,
      filterOn: [],
      perPage: 10,
      currentPage: 1,
    };
  },

  mounted() {
    this.getWallets();
  },

  methods: {
    getWallets() {
      this.loading = true;

      http.get("/AdminReports/wallets")
        .then((response) => {
          this.items = [];

          response.data.forEach((element) => {
            if (element.symbol == "IRT") {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 1,
                increase: null,
                decrease: null,
              });
            } else if (element.symbol == "IRTV") {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 2,
                increase: null,
                decrease: null,
              });
            } else if (element.symbol == "BTC") {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 3,
                increase: null,
                decrease: null,
              });
            } else {
              this.items.push({
                symbol: element.symbol,
                name: element.name,
                amount: element.amount,
                priority: 4,
                increase: null,
                decrease: null,
              });
            }
          });

          this.items.sort((a, b) => {
            return a.priority - b.priority;
          });

          this.items.sort((a, b) => {
            return b.amount - a.amount;
          });

          this.totalRows = this.items.length;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
        });
    },
  },
};
</script>

<style lang="scss">
.v-user-balances {
  padding: 24px;
  text-align: right;
  direction: rtl;

  table {
    background-color: #fff;

    .icon-container {
      display: flex;
    }
  }
}
</style>
